// Lazily load Razorpay Checkout (checkout.razorpay.com). Resolves once window.Razorpay exists.
let loading: Promise<void> | null = null;

export function loadRazorpay(): Promise<void> {
  if (typeof window !== "undefined" && (window as unknown as { Razorpay?: unknown }).Razorpay) {
    return Promise.resolve();
  }
  if (loading) return loading;
  loading = new Promise<void>((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => {
      loading = null;
      reject(new Error("Couldn't load the payment window. Check your connection and retry."));
    };
    document.body.appendChild(s);
  });
  return loading;
}
